import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  ${props => props.theme.css.container};
  margin: 40px auto;
  position: relative;

  .overlay {
    content: '';
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgb(255 255 255 / 0.7);
    z-index: 99;
    transition: all ease-in-out 0.3s;
  }

  h4 {
    margin: 0 0 20px;
    padding: 0 0 10px;
    width: 100%;
    box-sizing: border-box;
    font: ${font('default', 'normal', '18px/1.2')};
    border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};
  }
`
